import React, { useState, useEffect, useContext } from "react";
import bannerImg from "./styles/img/banner.jpg";
import logoImg from "./styles/img/logo.svg";
import styles from "./styles/WelcomePopup.module.css";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { getReferralAgencyData } from "../../../Utils/ReferralUtils";
import { UserData } from "../../../Context/DataContext";
import { getPrefilledData } from "../../../Utils/partnerUtils";
import { generateCode } from "../../../Utils/personalCode";

export function PartnerWelcomePopup({ onClose, date }) {
  const userData = UserData();
  const [showPopup, setShowPopup] = useState(true);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const closePopup = () => {
    onClose();
    //setShowPopup(false);
  };
  //We need to perfom some actions when the user is first accessing the platform
  // useEffect(() => {
  //   const user_id = userData?.UserData?.user_id;
  //   getPrefilledData().then((res) => {
  //     res
  //       .json()
  //       .then((data) => {
  //         // I have assets/beneficiaries/trustees.
  //         // I need to loop every item and assign an ID to them
  //         // I also need to check and filter how they are linked to each other
  //         // data.assets = data?.assets.map(e=>{return {...e, id:userData?.UserData?.user_id+`-A${e?.id}`}})
  //         // data.trustees = data?.trustees.map(e=>{return {...e, id:userData?.UserData?.user_id+`-T${e?.id}`}})
  //         // data.beneficiaries = data?.beneficiaries.map(e=>{return {...e, id:userData?.UserData?.user_id+`-B${e?.id}`}})
  //         const trustees = data?.trustees?.map((trustee, index) => {
  //           return {
  //             user_id: user_id + `-T${trustee?.id}`,
  //             name: trustee.name,
  //             additional_information: trustee.additional_information,
  //             email: trustee.email,
  //             phone_number: trustee.phone_number,
  //             awareness_status: Math.random() > 0.5 ? "true" : "false",
  //             profile_avatar: null,
  //           };
  //         });
  //         const beneficiaries = data?.beneficiaries?.map(
  //           (beneficiary, index) => {
  //             return {
  //               user_id: user_id + `-B${beneficiary?.id}`,
  //               name: beneficiary?.name,
  //               priority: beneficiary?.priority,
  //               message: beneficiary?.message,
  //               email: beneficiary?.email,
  //               phone_number: beneficiary?.phone_number,
  //               awareness_status: Math.random() > 0.5 ? "true" : "false",
  //               status: false,
  //               birth_date: beneficiary?.birth_date,
  //               personal_documents: [],
  //               visible_assets: data?.assets
  //                 .filter((e) => e?.beneficiaries?.includes(beneficiary?.id))
  //                 .map((e) => {
  //                   return user_id + `A-${e?.id}`;
  //                 }),
  //               trustees: [],
  //               profile_avatar: null,
  //               personal_code: generateCode(),
  //             };
  //           }
  //         );
  //         const assets = data?.assets?.map((asset, index) => {
  //           return {
  //             asset_id: user_id + `-B${asset?.id}`,
  //             asset_name: asset?.asset_name,
  //             asset_type: asset?.asset_type,
  //             description: asset?.description,
  //             credentials: '{"record_name":"This assets has no credentials"}',
  //             beneficiaries: asset?.beneficiaries.map(
  //               (e) => user_id + `-B${e}`
  //             ),
  //             trustees: asset?.trustees.map((e) => user_id + `-T${e}`),
  //             asset_files: [],
  //           };
  //         });
  //         console.log({
  //           assets,
  //           beneficiaries,
  //           trustees,
  //         });
  //         console.log({ assets, trustees, beneficiaries });
  //         userData?.setUserData({
  //           ...userData?.UserData,
  //           assets,
  //           trustees,
  //           beneficiaries,
  //         });
  //         // userData.Update(RandomId(10));
  //       })
  //       .catch((err) => {});
  //   });
  //   getReferralAgencyData()
  //     .then((res) => {
  //       res
  //         .json()
  //         .then((data) => {
  //           data.user_id = user_id + `L1`;
  //           userData.setUserData({
  //             ...userData.UserData,
  //             legal: [...userData.UserData.legal, data],
  //           });
  //         })
  //         .catch((e) => {});
  //     })
  //     .catch((err) => {});
  // }, []);
  return (
    <>
      {showPopup && (
        <div className={styles.popup_container}>
          <div className={styles.popup}>
            <div className={styles.header}>
              <div className={styles.title}>
                <div>{dublicatedcontent?.welcome_to}</div>
                <div className={styles.logo_row}>
                  <img className={styles.logo} src={logoImg} alt="Ostreon" />
                  <span>Inheritance!</span>
                </div>
              </div>
              <div className={styles.subtitle}>
                {dublicatedcontent?.dublicatedText236}
              </div>
              <button
                className={styles.close_btn}
                onClick={closePopup}
              ></button>
            </div>
            <img
              className={styles.img}
              src={bannerImg}
              alt={`${dublicatedcontent?.welcome_to} Ostreon`}
            />
            <div className={styles.footer}>
              <div className={styles.bottom_title}>
                {dublicatedcontent?.dublicatedText243}
                {date}.{dublicatedcontent?.dublicatedText244}
              </div>
              <button className={styles.bluebutton} onClick={closePopup}>
                {dublicatedcontent?.lets_start}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default PartnerWelcomePopup;
